<a
    [class]="'ap-button ap-button-link ap-button--' + this.variant() + ' ap-button-link--content-align-' + this.alignment()"
    [ngClass]="{
        'ap-button-link--wide': wide(),
        'ap-button-link--icon': iconName()
    }"
    [attr.target]="target()"
    [attr.type]="type()"
    [attr.rel]="rel()"
    [attr.ping]="ping()"
    [href]="href()"
    [attr.hreflang]="hreflang()"
    [attr.download]="download()"
    data-testid="link"
>
    @if (iconName()) {
        <ap-icon [name]="iconName()" size="large" color="inherit" data-testid="icon"></ap-icon>
    }
    <ng-content></ng-content>
    @if (target() === '_blank') {
        <div class="ap-sr-only">Opent in een nieuw tabblad</div>
    }
</a>
